import React, { useState, useEffect } from 'react';
import api from '../api/axios';

type Duel = {
  _id:       string;
  initiator: string;
  wager:     number;
  createdAt: string;
};

export default function DuelPage() {
  const [wager, setWager]       = useState(0);
  const [activeDuels, setActiveDuels] = useState<Duel[]>([]);
  const [myDuel, setMyDuel]     = useState<Duel | null>(null);
  const [choice, setChoice]     = useState<'rock'|'paper'|'scissors'|null>(null);
  const [statusMsg, setStatusMsg] = useState('');

  // Fetch open duels
  const fetchDuels = () =>
    api.get<Duel[]>('/duel')
       .then(r => setActiveDuels(r.data))
       .catch(console.error);

  useEffect(() => {
    fetchDuels();
    const iv = setInterval(fetchDuels, 10_000);
    return () => clearInterval(iv);
  }, []);

  // 1) Create + pick
  const create = async () => {
    const { data } = await api.post<{ _id: string }>('/duel', { wager });
    // now pick:
    setMyDuel({ _id: data._id, initiator: 'you', wager, createdAt: '' });
    setStatusMsg('Pick your move…');
  };

  const pick = async (c: 'rock'|'paper'|'scissors') => {
    if (!myDuel) return;
    setChoice(c);
    await api.post('/duel/pick', { duelId: myDuel._id, choice: c });
    setStatusMsg('Waiting for opponent…');
  };

  // 2) Join + resolve
  const join = async (duelId: string, initiator: string, c: 'rock'|'paper'|'scissors') => {
    setStatusMsg(`Challenging ${initiator} with ${c}…`);
    const { data } = await api.post<{ result: string }>('/duel/join', {
      duelId,
      choice: c
    });
    setStatusMsg(`Duel result: ${data.result}`);
    fetchDuels();
  };

  return (
    <div style={{ maxWidth:600, margin:'2rem auto' }}>
      <h2>Duel Arena</h2>

      {/* Challenger panel */}
      {!myDuel ? (
        <div>
          <p>Create a new duel:</p>
          <input
            type="number"
            value={wager}
            onChange={e => setWager(+e.target.value)}
            placeholder="Silver wager"
          />
          <button onClick={create}>Challenge</button>
        </div>
      ) : (
        <div>
          <p>You’re the challenger (wager {myDuel.wager}).</p>
          {!choice ? (
            ['rock','paper','scissors'].map(c => (
              <button key={c} onClick={() => pick(c as any)} style={{ marginRight:8 }}>
                {c.charAt(0).toUpperCase() + c.slice(1)}
              </button>
            ))
          ) : (
            <p>{statusMsg}</p>
          )}
        </div>
      )}

      <hr/>

      {/* Opponent panel */}
      <h3>Open duels</h3>
      {activeDuels.length > 0 ? (
        activeDuels.map(d => (
          <div key={d._id} style={{ marginBottom:12, padding:12, border:'1px solid #ccc' }}>
            <p>
              Challenger: {d.initiator} — wager {d.wager} silver
            </p>
            <p>Your move:</p>
            {(['rock','paper','scissors'] as const).map(c => (
              <button
                key={c}
                onClick={() => join(d._id, d.initiator, c)}
                style={{ marginRight:8 }}
              >
                {c.charAt(0).toUpperCase() + c.slice(1)}
              </button>
            ))}
          </div>
        ))
      ) : (
        <p>No one is waiting right now.</p>
      )}

      {statusMsg && <p><strong>{statusMsg}</strong></p>}
    </div>
  );
}
